<template>
    <main class="min-h-96 flex-col justify-center">
        <div
            v-if="active === true"
            class="mx-auto grow pb-6"
        >
            <AlertBox
                :state="config.state.download ? 'success' : 'danger'"
                :icon="MdiCellphoneText"
                :title="config.state.download ? t('notifyOk') : t('notifyError')"
            >
                <p
                    v-if="config.state.download === false"
                    class="py-1 text-sm"
                >
                    {{ t('previewFileNotCreated') }}
                    <br />{{ config.preset.fileName }}.{{ config.preset.extension }}
                </p>
                <p
                    v-if="config.state.download === true"
                    class="py-1 text-sm"
                >
                    {{ t('previewFileCreated') }}
                    <br />{{ config.preset.fileName }}.{{ config.preset.extension }}
                </p>
            </AlertBox>
        </div>
        <div
            v-if="active === true && config.state.download === true"
            class="relative mx-auto inline-block w-80 bg-cover p-4 pt-16 pb-20"
            style="background-image: url(/theme/default/m-frame-w.png)"
        >
            <div
                class="w-5/6 rounded-md border-blue-400 bg-blue-400 p-2 text-sm text-gray-50 shadow-sm"
            >
                {{ base64DecodeUTF(config.raw) }}
            </div>
            <div
                class="float-right mt-4 mb-32 w-5/6 rounded-md border-gray-300 bg-gray-300 p-2 text-sm text-gray-100 shadow-sm"
            >
                &nbsp;
            </div>
        </div>
    </main>
</template>
<script setup>
    import AlertBox from '../ui/AlertBox.vue';
    import { MdiCellphoneText } from 'materialdesignicons-vue3/icons/';
    import { base64DecodeUTF } from '../composables/utils';

    defineExpose({
        name: 'SMSPreview',
    });

    const props = defineProps({
        config: {
            type: Object,
            required: true,
        },
        active: {
            type: Boolean,
            default: false,
        },
    });
    const config = props.config;
    const active = props.active;
</script>
